import {BuildPageTabNamesEnum} from '../../../../../../../types'
import {
  isPipelineOverviewEnabled,
  isPipelinesCustomTabsEnabled,
} from '../../../../../../../utils/featureToggles'
import {notNull} from '../../../../../../../utils/guards'

export enum AdditionalJobDetailsTabs {
  GAME = 'game',
}

export const additionalJobDetailsTabs = {
  [AdditionalJobDetailsTabs.GAME]: {id: AdditionalJobDetailsTabs.GAME, title: '🎮 Take a break'},
}

export const supportedCustomTabs = isPipelinesCustomTabsEnabled
  ? [BuildPageTabNamesEnum.perfmon]
  : []

export const supportedTabs = [
  BuildPageTabNamesEnum.OVERVIEW,
  BuildPageTabNamesEnum.LOG,
  BuildPageTabNamesEnum.CHANGES,
  BuildPageTabNamesEnum.TESTS,
  isPipelineOverviewEnabled ? BuildPageTabNamesEnum.PARAMETERS : null,
  BuildPageTabNamesEnum.ARTIFACTS,
  ...supportedCustomTabs,
  AdditionalJobDetailsTabs.GAME,
].filter(notNull)
